import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/map.svg")